module.exports = __webpack_public_path__ + "media/images/icons/facilities/bbq-01b039be6870678ed79ec4008413da63.svg";